import React, { useState } from "react";

import { mdiChevronDown } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";

import type { JSX } from "react";

interface Props {
  title?: string;
  children: React.ReactNode;
  isCollapsable?: boolean;
  isCollapsedByDefault?: boolean;
  zIndex?: number;
  headerComponent?: JSX.Element;
  bodyStyle?: string;
  isFullSize?: boolean;
  isScrollableChildren?: boolean;
  withoutPadding?: boolean;
  className?: string;
  classNameHeader?: string;
}

export default function Block({
  title,
  children,
  isCollapsable,
  isCollapsedByDefault = false,
  zIndex,
  headerComponent,
  bodyStyle,
  isFullSize,
  isScrollableChildren,
  withoutPadding,
  className,
  classNameHeader,
}: Props): JSX.Element {
  const [isCollapsed, setIsCollapsed] = useState(isCollapsedByDefault);

  const blockClassNames = classNames(
    "flex flex-wrap gap-[0.78125rem] justify-between items-center border-b border-border px-6.25 py-[0.78125rem]",
    isCollapsable && "cursor-pointer",
    classNameHeader,
  );

  const childrenClassNames = classNames(
    !withoutPadding && "p-6.25",
    isCollapsable && isCollapsed && "hidden",
    isFullSize &&
      `h-full ${isScrollableChildren ? "overflow-auto" : "overflow-hidden"}`,
    bodyStyle,
  );

  const containerClassNames = classNames(
    "rounded-[0.3125rem] bg-card flex flex-col border border-solid border-border",
    isFullSize && "overflow-hidden h-full",
    className,
  );

  return (
    <div className={containerClassNames} style={{ zIndex }}>
      {title || headerComponent ? (
        <div
          className={blockClassNames}
          onClick={(): void =>
            isCollapsable ? setIsCollapsed(!isCollapsed) : undefined
          }
        >
          {title ? (
            <div>
              <div className="flex items-center justify-between gap-[0.46875rem] text-[1.171875rem]">
                <p className="font-medium">{title}</p>
                {isCollapsable ? (
                  <button className="text-muted-foreground" type="button">
                    <Icon
                      path={mdiChevronDown}
                      rotate={isCollapsed ? 180 : 0}
                      size={1.25}
                    />
                  </button>
                ) : null}
              </div>
            </div>
          ) : null}
          {headerComponent}
        </div>
      ) : null}
      <div className={childrenClassNames}>{children}</div>
    </div>
  );
}
